import { getURLPrefix } from "../../utils/getUrlPrefix";
import { SIDEBAR_COLORS } from "../../hooks/useDashboardTheme";
import {
  ADVERTISING,
  CONTENT,
  DEALS,
  DYNAMIC_PRICING,
  NEW_PRODUCT_LAUNCH,
} from "../../components/custom/merchandise/constants";

export const URL_PREFIX = getURLPrefix();

// Pattern B: `name` is a selector resolved at the consumer's t scope so the label
// is translated against whatever namespace the consumer binds.
// oxlint-disable-next-line @typescript-eslint/no-explicit-any
type NameSelector = ($: any) => any;

interface AppLink {
  id: string;
  name: NameSelector;
  app: string;
  color?: string;
  link: string;
  categoryLink?: (id: string) => string;
}

export const APP_LINKS: AppLink[] = [
  {
    id: "advertising",
    name: ($) => $.merchandising["Advertising"],
    app: ADVERTISING,
    color: SIDEBAR_COLORS.advertising,
    link: "/user/advertising/dashboard",
    categoryLink: (id: string) => {
      return `/user/advertising/dashboard/category/${id}`;
    },
  },
  {
    id: "dynamic_pricing",
    name: ($) => $.merchandising["Dynamic Pricing"],
    app: DYNAMIC_PRICING,
    color: SIDEBAR_COLORS.pricing,
    link: "/user/pricing/dashboard",
    categoryLink: (id: string) => `/user/pricing/management/category/${id}`,
  },
  {
    id: "deals",
    name: ($) => $.merchandising["Deals"],
    app: DEALS,
    link: "/user/merchandising/promotions",
    color: SIDEBAR_COLORS.promotions,
    categoryLink: () => `/user/merchandising/promotions`,
  },
  {
    id: "content",
    name: ($) => $.merchandising["Content"],
    app: CONTENT,
    link: "/user/content/quality/org",
    color: SIDEBAR_COLORS.product,
    categoryLink: (id: string) => `/user/content/quality/category/${id}`,
  },
  {
    id: "npi",
    name: ($) => $.merchandising["New Product Introductions"],
    app: NEW_PRODUCT_LAUNCH,
    link: "/user/npi/dashboard",
  },
];
